<template>
    <div v-loading="pageLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            class="rule-type"
            label-position="top"
        >
            <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :xl="24">
                    <el-form-item prop="ruleType" label="实名认证规则:">
                        <el-radio v-model="formData.ruleType" disabled :label="1" border>仅进行身份证二要素权威库验证</el-radio>
                        <el-radio v-model="formData.ruleType" disabled :label="2" border>进行身份证二要素权威库验证+人脸权威库验证（仅APP支持人脸验证）</el-radio>
                        <el-radio v-model="formData.ruleType" disabled :label="3" border>仅要求填写身份证二要素信息，但不进行权威库验证</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button
                    type="primary"
                    disabled
                    @click="onSubmit"
                    :loading="btnLoading"
                    >保存</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pageLoading: false,
            formData: {
                ruleType: 1
            },
            rules: {
                ruleType:  [{ required: true, message: "请选择实名认证规则" }],
            },
            btnLoading: false
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        // 获取详情
        async getDetail() {
            this.pageLoading = true;
            const response = await this.$request({
                url: "/realNameRule/info",
                method: "POST"
            }).finally(() => {
                this.pageLoading = false;
            });
            const {msg, state, result} = response.data;
            if (state != 1) return this.$message.error(msg);
            this.pageLoading = false;
            this.formData = result;
        },
        onSubmit () {
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const response = await this.$request({
                        url: "/realNameRule/save",
                        method: "POST",
                        data: this.formData,
                    });
                    const {msg, state} = response.data;
                    this.btnLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.$message.success('保存成功');
                }
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.rule-type {
    .el-radio {
        display: block;
        margin: 0px 0px 15px !important;
    }
}
</style>